module.exports = __webpack_public_path__ + "static/media/page-image.3b30fcf6.svg";